import actionTypes from './actionTypes';
import { action, generateErrorAction } from '../actions';
import API from '../../apis';

export const createCafeDiscountRequest = reqObject => {
  const request = () => dispatch => {
    dispatch(loading());
    return API.cafeDiscounts
      .createCafeDiscountRequest(reqObject)
      .then(res => dispatch(success(res)))
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.CREATE_CAFE_DISCOUNT_REQUEST_FAILED,
            reject: actionTypes.CREATE_CAFE_DISCOUNT_REQUEST_REJECT
          })
        );
        throw err;
      });
  };
  const loading = _ => action(actionTypes.CREATE_CAFE_DISCOUNT_REQUEST_LOADING);
  const success = res => action(actionTypes.CREATE_CAFE_DISCOUNT_REQUEST_SUCCESS, res);

  return request();
};

export const getMyCafeDiscountsList = query => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.cafeDiscounts
        .getMyCafeDiscountsList(query)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.GET_MY_CAFE_DISCOUNTS_LIST_FAILED,
              reject: actionTypes.GET_MY_CAFE_DISCOUNTS_LIST_REJECT
            })
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.GET_MY_CAFE_DISCOUNTS_LIST_LOADING);
  const success = res => action(actionTypes.GET_MY_CAFE_DISCOUNTS_LIST_SUCCESS, res);

  return request();
};


export const fetchAllCafeDiscountRequests = query => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.cafeDiscounts
        .fetchAllCafeDiscountRequests(query)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.FETCH_ALL_CAFE_DISCOUNT_REQUESTS_FAILED,
              reject: actionTypes.FETCH_ALL_CAFE_DISCOUNT_REQUESTS_REJECT
            })
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.FETCH_ALL_CAFE_DISCOUNT_REQUESTS_LOADING);
  const success = res => action(actionTypes.FETCH_ALL_CAFE_DISCOUNT_REQUESTS_SUCCESS, res);

  return request();
};


export const fetchAllCafeDiscountRequestArchives = query => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.cafeDiscounts
        .fetchAllCafeDiscountRequestArchives(query)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.FETCH_ALL_CAFE_DISCOUNT_REQUEST_ARCHIVES_FAILED,
              reject: actionTypes.FETCH_ALL_CAFE_DISCOUNT_REQUEST_ARCHIVES_REJECT
            })
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.FETCH_ALL_CAFE_DISCOUNT_REQUEST_ARCHIVES_LOADING);
  const success = res => action(actionTypes.FETCH_ALL_CAFE_DISCOUNT_REQUEST_ARCHIVES_SUCCESS, res);

  return request();
};


export const fetchCafeDiscountRequestDetailsById = id => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.cafeDiscounts
        .fetchCafeDiscountRequestDetailsById(id)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.FETCH_CAFE_DISCOUNT_REQUEST_BY_ID,
              reject: actionTypes.FETCH_CAFE_DISCOUNT_REQUEST_BY_ID_REJECT
            })
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.FETCH_CAFE_DISCOUNT_REQUEST_BY_ID_LOADING);
  const success = res => action(actionTypes.FETCH_CAFE_DISCOUNT_REQUEST_BY_ID_SUCCESS, res);

  return request();
};

export const updateCafeDiscountRequestStatus = (id, status, rejectionReason) => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.cafeDiscounts
        .updateCafeDiscountRequestStatus(id, status, rejectionReason)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.UPDATE_CAFE_DISCOUNT_REQUEST_FAILED,
              reject: actionTypes.UPDATE_CAFE_DISCOUNT_REQUEST_REJECT
            })
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.UPDATE_CAFE_DISCOUNT_REQUEST_LOADING);
  const success = res => action(actionTypes.UPDATE_CAFE_DISCOUNT_REQUEST_SUCCESS, res);

  return request();
};

export const clearCreateDiscountRequestForm = _ => {
  return action(actionTypes.CLEAR_CREATE_CAFE_DISCOUNT_REQUEST_FORM);
};
